// extracted by mini-css-extract-plugin
module.exports = {"promoContainer":"StreamCap__promoContainer--2-Ev2"};